import React from 'react'
import Typography from 'components/atoms/Typography'
import ReactHtmlParser from 'react-html-parser'
import { get } from 'lodash'

import './FlatCard.scss'

function FlatCard(props) {
  const description = get(props, 'description')
  const color = get(props, 'color')
  const title = get(props, 'title')

  return (
    <div className={`FlatCard type-${color} flat-card`}>
      <Typography variant="h5" component="h5" color="primary" cssClass="mb-3">
        {title}
      </Typography>
      <ul className="flat-card-list">
        <li>
          <div className="description-text">
            {ReactHtmlParser(description)}
          </div>
        </li>
      </ul>
    </div>
  )
}

export default FlatCard
